module.exports = __webpack_public_path__ + "media/images/checkmark-white-93f86ea6de8fbcc8ef2a305c32741b7d.svg";